import React from "react";

const SecondaryHero = ({ preTitle, heroTitle, heroSubtitle }) => {
	return (
		<>
			<div className="bg-white">
				<div className="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
					<div className="text-left">
						<p className="text-base font-semibold text-yellow-600 tracking-wide uppercase mb-0">
							{preTitle}
						</p>
						<h1 className="mt-1 text-4xl font-extrabold text-gray-900 sm:text-5xl sm:tracking-tight lg:text-6xl">
							{heroTitle}
						</h1>
						<p className="mt-5 mx-auto text-xl text-gray-500 leading-relaxed">{heroSubtitle}</p>
					</div>
				</div>
			</div>
		</>
	);
};

export default SecondaryHero;
